import React from "react";
import AddProductButton from "./AddProductButton/AddProductButton";
import KnowledgeBaseAccessControl from "components/dashboard/KnowledgeBase/KnowledgeBaseAccessControl/KnowledgeBaseAccessControl";
import { PRODUCT_CREATE_PERMISSION } from "components/dashboard/KnowledgeBase/permissions";
import "./ProductDashboardHeader.scss";

const ProductDashboardHeader = ({
    products,
    selectedProduct,
    handleProductSelect,
    retrieveProducts,
}) => {
    return (
        <>
            <div className='product__dashboard__header'>
                <div className='product__dashboard__header--contents'>
                    <div>
                        <h1 className='product__dashboard__header--contents--title'>
                            Product Set-up
                        </h1>
                        <p className='product__dashboard__header--contents--sub__title'>
                            Add & change product information
                        </p>
                    </div>
                    <KnowledgeBaseAccessControl
                        baseResources={PRODUCT_CREATE_PERMISSION}>
                        <AddProductButton
                            retrieveProducts={retrieveProducts}
                            handleProductSelect={handleProductSelect}
                        />
                    </KnowledgeBaseAccessControl>
                </div>
            </div>
        </>
    );
};

export default ProductDashboardHeader;
